import { render, staticRenderFns } from "./huikuForm.vue?vue&type=template&id=25741d8d&scoped=true&"
import script from "./huikuForm.vue?vue&type=script&lang=js&"
export * from "./huikuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25741d8d",
  null
  
)

export default component.exports